import { z } from 'zod';

export const allowedRoleIdSchema = z.string();
